import { sanitizeFormData } from './sanitize'

interface FormData {
  email: string;
  subject: string;
  description: string;
  requestType: string;
  impact: string;
  allowImpersonation: boolean;
  functionalArea: string;
  usageContext: string;
}

function createHiddenInput(name: string, value: string): HTMLInputElement {
  const input = document.createElement('input');
  input.type = 'hidden';
  input.name = name;
  input.value = value;
  return input;
}

export function submitToSalesforce(formData: FormData): Promise<void> {
  return new Promise((resolve, reject) => {
    try {
      const sanitizedData = sanitizeFormData(formData)
      const formEl = document.createElement('form')
      formEl.action = 'https://webto.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8&orgId=00D3X000001tDZx';
      formEl.method = 'POST';
      formEl.style.display = 'none';
      formEl.target = 'hidden_iframe';

      const iframe = document.createElement('iframe');
      iframe.name = 'hidden_iframe';
      iframe.style.display = 'none';
      document.body.appendChild(iframe);

      // Append form fields with sanitized data
      formEl.appendChild(createHiddenInput('orgid', '00D3X000001tDZx'))
      formEl.appendChild(createHiddenInput('00NW5000009Dqus', sanitizedData.email))
      formEl.appendChild(createHiddenInput('subject', sanitizedData.subject))
      formEl.appendChild(createHiddenInput('description', sanitizedData.description))
      formEl.appendChild(createHiddenInput('00NW5000008wMef', sanitizedData.requestType))
      formEl.appendChild(createHiddenInput('00NW5000008wLsH', sanitizedData.impact))
      formEl.appendChild(createHiddenInput('00NW5000008xIab', sanitizedData.allowImpersonation ? 'Yes' : 'No'))
      formEl.appendChild(createHiddenInput('00NW5000008xHzV', sanitizedData.functionalArea))
      formEl.appendChild(createHiddenInput('00NW5000008wPpR', sanitizedData.usageContext))
      formEl.appendChild(createHiddenInput('retURL', 'submitted'));

      // Form submission handler
      iframe.onload = () => {
        try {
          document.body.removeChild(iframe);
          document.body.removeChild(formEl);
          resolve();
        } catch (error) {
          reject(error);
        }
      };

      iframe.onerror = (error) => {
        reject(error);
      };

      document.body.appendChild(formEl);
      formEl.submit();
    } catch (error) {
      reject(error);
    }
  })
}
